module.exports = __webpack_public_path__ + "img/PINGAN-SPD.1554acad.png";